import { useMutation } from "@tanstack/react-query";
import { createUser } from "../../../api/users/createUser";

export const useCreateUser = () => {

  return useMutation({
    mutationKey: ["createUser"],
    mutationFn: createUser
  });
};
